import { z } from 'zod';
import { OrganizationJSONSchema } from './organizations/organization';

export const AccessJSONSchema = z.object({
	result: z.object({
		id: z.uuidv4(),
		organizations: z.array(OrganizationJSONSchema),
	}),
});

export type IAccessJSON = z.infer<typeof AccessJSONSchema>;
